const AUTH_PATHS = ["/login", "/register", "/forget-password", "/reset", "/accept-invitation"];
const LEGACY_STORAGE_KEY = "lbhq_affiliate_ref";

function firstValue(value) {
  if (value == null || value === "") {
    return null;
  }
  const raw = Array.isArray(value) ? value[0] : value;
  const text = String(raw).trim();
  return text || null;
}

function clearPersistedAffiliateRef() {
  try {
    window.localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch (error) {
    // ignore
  }
  try {
    window.sessionStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch (error) {
    // ignore
  }
  try {
    document.cookie = `${LEGACY_STORAGE_KEY}=; path=/; max-age=0`;
    document.cookie = `${LEGACY_STORAGE_KEY}=; path=/; max-age=0; domain=.linkbuildinghq.com`;
  } catch (error) {
    // ignore
  }
}

clearPersistedAffiliateRef();

export function getRefFromUrl() {
  try {
    return firstValue(new URLSearchParams(window.location.search).get("ref"));
  } catch (error) {
    console.warn("Failed to parse affiliate ref from URL", error);
    return null;
  }
}

export function getRefFromQuery(query = {}) {
  return firstValue(query?.ref);
}

export function withRouteRef(routeQuery = {}, extra = {}) {
  const query = { ...routeQuery, ...extra };
  const ref = firstValue(routeQuery.ref);
  if (ref) {
    query.ref = ref;
  }
  return query;
}

export function isAuthPath(path) {
  return AUTH_PATHS.includes(path);
}
